import PropTypes from 'prop-types'
import React from 'react'
import { Modal } from 'semantic-ui-react'
import { StyledModal } from './SupportModal.styled.js'
import { isDrayNowHost } from '../../../lib/config/multitenancy.js'

const SupportModal = (props) => {
  const isDrayNow = isDrayNowHost()
  const heading = isDrayNow ? 'DrayNow Support' : 'ModalView Support'
  const email = isDrayNow ? 'support@draynow.com' : 'support@modalview.com'

  return (
    <StyledModal
      trigger={props.children}
      size='tiny'
      closeIcon
      className='support'
      dimmer
      closeOnDimmerClick
      closeOnEscape
      data-testid='support-modal'
      {...props}
    >
      <Modal.Header>{heading}</Modal.Header>
      <Modal.Content>
        <p>Contact us and speak with a real human, right away.</p>
        <p className='support-method'>
          <span className='method'>E-mail</span>
          <a href={`mailto:${email}`} data-testid='support-submit-btn'>
            {email}
          </a>
        </p>
      </Modal.Content>
    </StyledModal>
  )
}

SupportModal.propTypes = {
  children: PropTypes.element,
}

export default SupportModal
